// Locale Mutations

export const setRtl = (state, payload) => {
  state.isRtl = payload
}

export const changeLocales = (state, payload) => {
  state.currentLocale = payload
}

export const setCountriesList = (state, payload) => {
  state.countriesList = payload
}
